'use client'

import { setShippingMethodAction } from '@/services'
import { useCallback } from 'react'

interface UseShippingMethodProps {
  cartId: string
  refetchCart: () => void
}
export const DEFAULT_SHIPPING_METHOD = { method_code: 'flatrate', carrier_code: 'flatrate' }
export const useShippingMethod = ({ cartId, refetchCart }: UseShippingMethodProps) => {
  const submitShippingMethod = useCallback(
    (data: { method_code?: string; carrier_code?: string }) => {
      const dataSubmit = {
        setShippingMethodsOnCartInput: {
          cart_id: cartId,
          shipping_methods: [
            {
              ...data,
            },
          ],
        },
      }

      setShippingMethodAction(dataSubmit)
        .then((res) => {
          console.log('Shipping method set:', res)
          refetchCart()
        })
        .catch((error) => {
          console.error('Error setting shipping method:', error)
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cartId]
  )

  return {
    submitShippingMethod,
  }
}